import React from "react";
import { Link } from "Components/Base/Navigation/Link";

export const TITLE_LINK_SX = {
  color: "inherit",
  fontWeight: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  letterSpacing: "inherit",
};

export const renderTitleLinkContent = (title, titleLink) => {
  if (titleLink?.href) {
    return (
      <Link
        href={titleLink.href}
        color="inherit"
        underline="hover"
        {...(titleLink.linkTitle ? { title: titleLink.linkTitle } : {})}
        sx={TITLE_LINK_SX}
      >
        {title}
      </Link>
    );
  }

  return title;
};
